import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import expirationMonthsCodes from '../modules/data/expiration-months-codes';
import { setExpirationMonth, setMonthsFromNow } from '../redux/modules/registration';
import monthsFromNowText from '../modules/monthsFromNow';

class ExpirationRow extends Component {
  constructor() {
    super();
    this.state = { monthMode: true };
  }

  renderButtons() {
    return expirationMonthsCodes.map((item, i) => {
      const { month, code, tip, monthNum } = item;
      const label = this.state.monthMode ? month : code;
      const id = `ButtonMonth${i}`;

      const btnClass = classnames({
        Button: true,
        MonthButton: true,
        'Button--selected': this.props.selectedMonthNumber === monthNum,
      });

      return (
        <button
          key={id}
          className={btnClass}
          id={id}
          data-tooltip={tip}
          onClick={() => {
            this.props.setExpirationMonth(monthNum);
          }}
        >{label}
        </button>
      );
    });
  }

  forceMonth(num) {
    this.props.setMonthsFromNow(num);
  }

  getNumberMonthRow() {
    const { selectedMonthNumber, today, monthsFromNow } = this.props;
    const fromNow = monthsFromNowText(today, selectedMonthNumber).replace(/\s+?months/, '');
    const months = fromNow.split('/').map(n => Number(n));

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((num) => {
      const key = `monthKey${num}`;
      const isActive = months.indexOf(num) > -1;
      const isHighlighted = isActive && Number(monthsFromNow) === num;

      const btnClass = classnames({
        Button: true,
        'MonthNumbers-button': true,
        'Button--selected': isHighlighted,
        'MonthNumbers--disabled': !isHighlighted && !isActive,
      });

      return (
        <button
          key={key}
          className={btnClass}
          onClick={() => {
            if (isActive) {
              this.forceMonth(num);
            }
          }}
        >{num}</button>
      );
    });
  }

  getModeButtons() {
    return (
      <div className="ExpiMode">
        <span className="ExpiMode-note">Mode: </span>
        <button
          className={`ExpiMode-btn ${this.state.monthMode ? 'ExpiMode-btn--selected' : ''}`}
          onClick={() => this.setState({ monthMode: true })}
        >DOB/Expiration</button>

        <button
          className={`ExpiMode-btn ${this.state.monthMode ? '' : 'ExpiMode-btn--selected'}`}
          onClick={() => this.setState({ monthMode: false })}
        >For-Hire Co. Name</button>
      </div>
    );
  }

  render() {

    return (
      <div className="Box ExpiMode-wrapper">

        <div className="ExpiMode-top">
          {this.getModeButtons()}
        </div>

        <div className="ExpiMode-bottom">
          {this.renderButtons()}
          <div className="MonthNumbers">
            <span>Months: </span>
            {this.getNumberMonthRow()}
          </div>
        </div>


      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedMonthNumber: state.registration.selectedMonthNumber,
    monthsFromNow: state.registration.monthsFromNow,
    today: state.registration.today,
  };
};

export default connect(mapStateToProps, { setExpirationMonth, setMonthsFromNow })(ExpirationRow);



// WEBPACK FOOTER //
// ./src/containers/ExpirationRow.js